export default class FetchACF {
  constructor(element) {
    this.element = element;
    this.pageId = element.dataset.pageId || null;
    this.postId = element.dataset.postId || null;
    this.cptSlug = element.dataset.cptSlug || null;
    this.lang = document.documentElement.lang || 'fr';
    this.init();
  }

  buildEndpoint() {
    const baseUrl = window.wpUrl + 'wp-json/wp/v2';

    if (this.pageId) {
      return `${baseUrl}/pages/${this.pageId}?lang=${this.lang}`;
    }
    if (this.postId) {
      return `${baseUrl}/posts/${this.postId}?lang=${this.lang}`;
    }
    if (this.cptSlug) {
      return `${baseUrl}/${this.cptSlug}?lang=${this.lang}`;
    }

    console.error('FetchACF: Aucun ID ou slug fourni.');
    return null;
  }

  async init() {
    const endpoint = this.buildEndpoint();
    console.log(endpoint);
    if (!endpoint) return;

    try {
      const response = await fetch(endpoint);
      const json = await response.json();

      const acfSource = json.acf_fields || json.acf || json.meta || {};

      Object.entries(acfSource).forEach(([key, value]) => {
        const target = this.element.querySelector(`[data-acf-key="${key}"]`);
        if (!target) return;

        if (target.tagName.toLowerCase() === 'a') {
          // Liens
          if (typeof value === 'object' && value !== null) {
            target.href = value.url ?? '#';
          } else {
            target.href = value ?? '#';
          }
        } else if (target.tagName.toLowerCase() === 'img') {
          // Images
          if (typeof value === 'object' && value !== null) {
            target.src = value.url ?? '';
            if (value.alt) target.alt = value.alt;
          } else {
            target.src = value ?? '';
          }
        } else {
          // Texte
          if (typeof value === 'string') {
            if (value.trim().startsWith('<')) {
              // WYSIWYG
              target.innerHTML = value;
            } else if (value.includes('\n')) {
              // Textarea
              const formatted = value
                .split(/\n+/)
                .map(line => `<p>${line}</p>`)
                .join('');
              target.innerHTML = formatted;
            } else {
              // Texte simple
              target.textContent = value;
            }
          } else {
            target.textContent = value ?? '—';
          }
        }

        target.dataset.acfValue = value ?? '—';
        if (!value) target.classList.add('acf-empty');
        else target.classList.remove('acf-empty');
      });
    } catch (err) {
      console.error('FetchACF: Erreur lors du fetch', err);
    }
  }
}
